/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Port_Not_AllowedInputs */

const en_site_url_error_port_not_allowed = /** @type {(inputs: Site_Url_Error_Port_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only sites on standard ports (80/443) can be dissected.`)
};

const id_site_url_error_port_not_allowed = /** @type {(inputs: Site_Url_Error_Port_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya situs di port standar (80/443) yang bisa dibedah.`)
};

/**
* | output |
* | --- |
* | "Only sites on standard ports (80/443) can be dissected." |
*
* @param {Site_Url_Error_Port_Not_AllowedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_port_not_allowed = /** @type {((inputs?: Site_Url_Error_Port_Not_AllowedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Port_Not_AllowedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_port_not_allowed(inputs)
	return en_site_url_error_port_not_allowed(inputs)
});